import { FC, useState } from 'react';
import { message, Modal, Button } from 'antd';
import { useAppDispatch } from '../../methods/redux/hooks';
import { deactivatePhone } from '../../methods/redux/reducers/user-profile';

interface IDeactivatePhoneModal {
	details: { profile: { isVerifiedPhone: boolean; _id: string } };
	setRefresh: Function;
}
const DeactivatePhoneModal: FC<IDeactivatePhoneModal> = ({
	details,
	setRefresh,
}) => {
	const dispatch = useAppDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			const payload = {
				userId: details?.profile?._id,
				requestId: details?.profile?._id,
				status: 'declined',
			};
			await dispatch(deactivatePhone(payload));
			setRefresh(Math.random());
		} catch (error) {
			message.error('Failed to deactivate phone');
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to revoke this phone number verification?',
			onOk() {
				handleSubmit();
			},
		});
	};
	return (
		<Button
			onClick={() => {
				confirm();
			}}
			type="primary"
			size="small"
			disabled={isLoading || !details?.profile?.isVerifiedPhone}
		>
			{isLoading ? 'Loading...' : 'Revoke Verification'}
		</Button>
	);
};

export default DeactivatePhoneModal;
